import {Component, OnInit} from '@angular/core';
import {EditionDialogComponent} from "../../../basic-entity-front/edition-dialog/edition-dialog.component";
import {
    BasicEntityTableColumnDescriptionOrString
} from "../../../basic-entity-front/basic-entity-table/basic-entity-table.component";
import {DescuentoGeneral} from "../../../model/documentacion/descuento-general.model";

@Component({
    selector: 'app-descuentos-generales',
    template: '<be-table [modelType]="model" [columnsToDisplay]="columns"></be-table>',
    styleUrls: ['./descuentos-generales.component.scss']
})
export class DescuentosGeneralesComponent implements OnInit {
    model = DescuentoGeneral;
    dialog = EditionDialogComponent;
    columns: BasicEntityTableColumnDescriptionOrString[] = [
        {key: "id", hiddenDisplayable: true, weight: 1},
        {key: "descripcion", weight: 2},
        {key: "metodoFabricacion", weight: 2},
        {key: "material", weight: 2},
        {key: "trabajo", weight: 2},
        {key: "subTrabajo", weight: 2},
        {key: "acabado", weight: 2},
    ];

    constructor() {
    }

    ngOnInit(): void {
    }

}
